import { useCountdown } from 'app/hooks/use-countdown';
import { checkIsFunction } from 'app/utils/check-is-function';
import { _t } from 'app/utils/i18n';
import { getFromLocalStorage } from 'app/utils/localStorage';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../Loader';
import styles from './CountDownLoader.module.scss';
interface Props {
  timeStartMilliseconds: 120000 | 900000 | 60000;
  isComplete?: any;
  smallSize?: boolean;
  checkStatus?: any;
  moduleName?: string;
}
const isEn = getFromLocalStorage('LNG') == 'en' ? true : false;
export const CountDownLoader: FunctionComponent<Props> = ({
  isComplete,
  smallSize,
  checkStatus,
  moduleName = '',
  timeStartMilliseconds = 120000,
}) => {
  const { id }: any = useParams();
  const LOCAL_KEY = `timeCounter_${moduleName}_${id}`;
  const LOCAL_KEY_MINUTES = `${LOCAL_KEY}_MINUTES`;
  const [countDownDate] = useState(() => {
    if (getFromLocalStorage(LOCAL_KEY)) {
      const date = new Date(getFromLocalStorage(LOCAL_KEY));
      return date?.getTime();
    } else {
      const date = new Date();
      date?.setTime(date?.getTime() + timeStartMilliseconds);
      localStorage.setItem(
        LOCAL_KEY_MINUTES,
        Math.floor((date.getTime() % (1000 * 60 * 60)) / (1000 * 60)) as any
      );
      return date;
    }
  });

  const clearLocalStorage = () => {
    localStorage.removeItem(LOCAL_KEY);
    localStorage.removeItem(LOCAL_KEY_MINUTES);
  };

  const { minutes, seconds, isTimerFinish } = useCountdown(countDownDate, {
    onUnMount: ({ minutes, milliseconds }) => {
      if (minutes < 0) {
        checkIsFunction(checkStatus);
        clearLocalStorage();
        return;
      }

      const date = new Date();
      date?.setTime(date?.getTime() + milliseconds);

      localStorage.setItem(LOCAL_KEY, date as any);
    },
    onChange: ({ minutes }) => {
      if (minutes <= getFromLocalStorage(LOCAL_KEY_MINUTES)) {
        localStorage.setItem(LOCAL_KEY_MINUTES, (minutes - 1) as any);
        checkIsFunction(checkStatus);
      }

      if (minutes < 0) {
        checkIsFunction(checkStatus);
        clearLocalStorage();
        return;
      }
    },
    removeFun: () => {
      localStorage.removeItem(LOCAL_KEY);
      localStorage.removeItem(LOCAL_KEY_MINUTES);
    },

    enabled: !isComplete,
  });
  useEffect(() => {
    setTimeout(() => {
      clearLocalStorage();
    }, timeStartMilliseconds);
  }, []);

  return (
    <div
      className={
        smallSize
          ? isTimerFinish
            ? styles.finishText
            : styles.smallSizeLoader
          : styles.CountDownLoader
      }
      data-testid="CountDownLoader-testid"
    >
      {minutes && seconds ? (
        !isTimerFinish ? (
          <div>
            {isEn
              ? `${minutes} ${_t(`hashtags:m`)}: ${seconds} ${_t(`hashtags:s`)}`
              : ` ${seconds} ${_t(`hashtags:s`)} : ${minutes} ${_t(
                  `hashtags:m`
                )}`}
          </div>
        ) : (
          <p>{_t('hashtags:it_took_time_more_than_useual')}</p>
        )
      ) : (
        <Loader smallSize />
      )}
    </div>
  );
};
